import React, { useState, useEffect } from "react";
import { Profile, Toast } from "../../Components";
import { influencerService } from "../../Services";

export default function ReferFriend(props) {
  const [referurl, setReferurl] = useState("");
  const [toastList, setToastList] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await influencerService.getReferralUrl();
        setReferurl(res["data"]);
      } catch (err) {
        addToast({
          error: true,
          msg: err?.message || "Something went wrong.",
          id: `${Date.now()}-${toastList.length}`,
        });
      }
    }
    fetchData();
  }, []);

  const addToast = (data) => {
    setToastList((prev) => [
      ...prev,
      { ...data, id: `${Date.now()}-${prev.length}` },
    ]);
  };

  const copyBtn = (data) => {
    navigator.clipboard.writeText(data);
    addToast({
      error: false,
      msg: "Link copied to clipboard.",
    });
  };

  return (
    <div className="min-h-screen px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full mb-4 shadow-lg">
            <svg
              className="w-10 h-10 text-white"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3z" />
            </svg>
          </div>
          <h1 className="text-3xl font-bold bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent mb-4">
            Welcome to the TAMA Influencer Rewards Program!
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Are you ready to take your influencer journey to the next level?
            We've got something special just for you.
          </p>
        </div>

        {/* Main Card */}
        <div className="bg-white/80 backdrop-blur-sm shadow-2xl rounded-3xl p-6 border border-white/20">
          {/* Content */}
          <div className="space-y-4 text-gray-700">
            <h3 className="text-xl font-semibold text-green-700">
              Refer Friends, Earn Rewards!
            </h3>

            <div>
              <h6 className="font-semibold text-emerald-600 mb-4">
                Here's How It Works:
              </h6>
              <div className="grid md:grid-cols-3 gap-4">
                <div className="p-4 bg-gradient-to-r from-green-100 to-emerald-100 rounded-lg border-l-4 border-green-500">
                  <h4 className="font-bold text-green-700 mb-2">
                    Share Your Link:
                  </h4>
                  <p className="text-sm text-gray-600">
                    Invite your influencer friends to join TAMA with your unique
                    referral link.
                  </p>
                </div>
                <div className="p-4 bg-gradient-to-r from-emerald-100 to-teal-100 rounded-lg border-l-4 border-emerald-500">
                  <h4 className="font-bold text-emerald-700 mb-2">
                    Grow Together:
                  </h4>
                  <p className="text-sm text-gray-600">
                    As your friends become active on TAMA, you both earn
                    fantastic rewards.
                  </p>
                </div>
                <div className="p-4 bg-gradient-to-r from-teal-100 to-cyan-100 rounded-lg border-l-4 border-teal-500">
                  <h4 className="font-bold text-teal-700 mb-2">
                    Enjoy the Perks:
                  </h4>
                  <p className="text-sm text-gray-600">
                    Get exclusive campaign opportunities, early access to
                    features, and more!
                  </p>
                </div>
              </div>
            </div>

            <h6 className="font-semibold text-emerald-600">
              Join the TAMA Community
            </h6>
            <p>
              Discover the power of community and collaboration. Together, we
              rise higher!
            </p>

            <h6 className="font-semibold text-emerald-600">
              Become a TAMA Influencer Ambassador
            </h6>
            <p>
              Ready to get started? Use the unique link below to refer your
              friends and unlock incredible rewards!
            </p>
          </div>

          {/* Referral Link Section */}
          <div className="flex items-center gap-3 mt-4">
            <input
              type="text"
              value={referurl}
              readOnly
              className="flex-1 px-4 py-2 border border-emerald-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-emerald-400"
            />
            <button
              onClick={() => copyBtn(referurl)}
              className="px-5 py-2 font-medium text-white rounded-lg shadow-md bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 transition"
            >
              Copy
            </button>
          </div>

          <p className="mt-6 text-sm text-gray-500 text-center">
            Questions? We're here to help. Reach out anytime.
          </p>
        </div>
      </div>

      {toastList.length > 0 && (
        <Toast type="refer" list={toastList} setList={setToastList} />
      )}
    </div>
  );
}
